import jcbLogo from "../assets/img/icons/jcb.png";
import visaLogo from "../assets/img/icons/visa.png";
import mastercardlogo from "../assets/img/icons/mastercard.png";
import americanexpresslogo from "../assets/img/icons/amex.png";
import discoverlogo from "../assets/img/icons/discover.png";
import dinersclublogo from "../assets/img/icons/dinersclub.png";
import unionpaylogo from "../assets/img/icons/unionpay.png";
import maestrologo from "../assets/img/icons/maestro.png";
import paypallogo from "../assets/img/icons/paypal.png"


const paymentLogoCards = [
    {
        name: "Visa",
        logoUrl: visaLogo // Replace with actual URL
    },
    {
        name: "Mastercard",
        logoUrl: mastercardlogo
    },
    {
        name: "American Express",
        logoUrl: americanexpresslogo
    },
    {
        name: "Discover",
        logoUrl: discoverlogo
    },
    {
        name: "JCB",
        logoUrl: jcbLogo
    },
    {
        name: "Diners Club",
        logoUrl: dinersclublogo 
    },
    {
        name: "UnionPay",
        logoUrl: unionpaylogo
    },
    {
        name: "Maestro",
        logoUrl: maestrologo
    },
    {
        name: "Paypal",
        logoUrl: paypallogo 
    }
];

export default paymentLogoCards;